import React, { useState } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import saveIcon from "../../assets/images/save-icon.svg";

const ChangePassword = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const user = localStorage.getItem("user"); 
  const userData = JSON.parse(user);
  const user_id = userData?._id;

  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(""); // For success or error message

  const validatePasswords = () => {
    let tempErrors = {};
    setMessage("");

    if (!passwords.currentPassword) {
      tempErrors.currentPassword = "Current password is required.";
    }

    if (!passwords.newPassword) {
      tempErrors.newPassword = "New password is required.";
    } else if (passwords.newPassword.length < 6) {
      tempErrors.newPassword = "Password must be at least 6 characters long.";
    }

    if (!passwords.confirmPassword) {
      tempErrors.confirmPassword = "Confirm password is required.";
    } else if (passwords.newPassword !== passwords.confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0; // Returns true if no errors
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords({ ...passwords, [name]: value });
  };

  const handleSave = async () => {
    if (validatePasswords()) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/user/update/password/${user_id}`, // Corrected with backticks for string interpolation
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              oldPassword: passwords.currentPassword,
              password: passwords.newPassword,
              confirmPassword: passwords.confirmPassword,
            }),
          }
        );
  
        const data = await response.json();
  
        if (response.ok) {
          setMessage("Password changed successfully!");
          setErrors({});
        } else {
          setMessage(data.message || "Failed to change password.");
        }
      } catch (error) {
        setMessage("An error occurred. Please try again.");
      }
    }
  };

  const passwordBox = {
    currentPass: {
      width: {sx:"100%",md:"48.5%"},
    },
    newPassPass: {
      width: {sx:"100%",md:"48.5%"},
    },
    confirmPass: {
      width: {sx:"100%",md:"48.5%"},
    },
    newPassBox: {
      display: "flex",
      justifyContent: "space-between",
    },
    btnSavePass: {
      background: "#065F9C",
      borderRadius: "10px",
      fontSize: "16px",
      width: "auto",
      padding: "15px 30px",
      lineHeight: "1.2",
    },
  };

  return (
    <Box
      className="passwordRowBox"
      sx={{
        maxWidth: "100%",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Current Password */}
      <Box className="currentPassRow">
        <TextField
          style={passwordBox.currentPass}
          sx={{
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
          label="Current Password"
          type={showCurrentPassword ? "text" : "password"}
          name="currentPassword"
          value={passwords.currentPassword}
          onChange={handlePasswordChange}
          fullWidth
          error={!!errors.currentPassword}
          helperText={errors.currentPassword}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  edge="end"
                >
                  {showCurrentPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box className="newPassRow" sx={{display:{xs:"flex",sm:"flex",md:"flex"}, flexDirection:{xs:"column",sm:"column",md:"row"}, gap:{xs:"15px",sm:"15px",md:"15px"}}}>
        {/* New Password */}
        <TextField
          style={passwordBox.newPassPass}
          sx={{
            marginBottom: 0,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
          label="New Password"
          type={showNewPassword ? "text" : "password"}
          name="newPassword"
          value={passwords.newPassword}
          onChange={handlePasswordChange}
          fullWidth
          error={!!errors.newPassword}
          helperText={errors.newPassword}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  edge="end"
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Confirm Password */}
        <TextField
          style={passwordBox.confirmPass}
          sx={{
            marginBottom: 0,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
            },
          }}
          label="Confirm Password"
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          value={passwords.confirmPassword}
          onChange={handlePasswordChange}
          fullWidth
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}          
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  edge="end"
                >
                  {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Message */}
      {message && (
        <Typography
          color={message === "Password changed successfully!" ? "success.main" : "error.main"}
          sx={{ marginBottom: 2 }}
        >
          {message}
        </Typography>
      )}

      {/* Save Button */}
      <Box className="savePassWord">
        <Button
          style={passwordBox.btnSavePass}
          variant="contained"
          color="primary"
          onClick={handleSave}
          fullWidth
        >
          <img
            src={saveIcon}
            alt="Save Password"
            style={{ width: 24, height: 24 }}
          />
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ChangePassword;
